import { CdkTableModule } from '@angular/cdk/table';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatSelectFilterModule } from 'mat-select-filter';
import { 
// Navigation.
MatToolbarModule, MatSidenavModule, MatMenuModule, 
// Layout
MatListModule, MatGridListModule, MatExpansionModule, MatCardModule, MatTabsModule, MatStepperModule, 
// Buttons & Indicators
MatButtonModule, MatButtonToggleModule, MatChipsModule, MatIconModule, MatProgressSpinnerModule, MatProgressBarModule, MatBadgeModule, 
// Form Controls.
MatCheckboxModule, MatInputModule, MatRadioModule, MatDatepickerModule, MatNativeDateModule, MatAutocompleteModule, MatSliderModule, MatSlideToggleModule, MatSelectModule, 
// Popups & Modals
MatDialogModule, MatTooltipModule, MatSnackBarModule, 
// Tables
MatTableModule, MatSortModule, MatPaginatorModule, MatFormFieldDefaultOptions } from '@angular/material';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { MatMomentDatetimeModule } from '@mat-datetimepicker/moment';
var appearance = {
    appearance: 'fill'
};
var matModules = [
    // Navigation.
    MatToolbarModule,
    MatSidenavModule,
    MatMenuModule,
    // Layout
    MatListModule,
    MatGridListModule,
    MatExpansionModule,
    MatCardModule,
    MatTabsModule,
    MatStepperModule,
    // Buttons & Indicators
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatChipsModule,
    MatBadgeModule,
    // Form Controls.
    MatCheckboxModule,
    MatInputModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSelectModule,
    // Popups & Modals
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,
    // Table
    CdkTableModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    //Moment
    MatMomentDateModule,
    NgxMatSelectSearchModule,
    MatDatepickerModule,
    // use this if you want to use native javascript dates and INTL API if available
    // MatNativeDatetimeModule,
    MatMomentDatetimeModule,
    MatDatetimepickerModule,
    MatSelectFilterModule
];
var ɵ0 = { useUtc: true }, ɵ1 = {
    hasBackdrop: true,
    panelClass: 'kt-mat-dialog-container__wrapper',
    height: 'auto',
    width: '900px'
}, ɵ2 = appearance;
var SharedMaterialModule = /** @class */ (function () {
    function SharedMaterialModule() {
    }
    return SharedMaterialModule;
}());
export { SharedMaterialModule };
export { ɵ0, ɵ1, ɵ2 };
